import { render, staticRenderFns } from "./EmbedFooter.vue?vue&type=template&id=167c19ae&scoped=true&"
import script from "./EmbedFooter.vue?vue&type=script&lang=js&"
export * from "./EmbedFooter.vue?vue&type=script&lang=js&"
import style0 from "./EmbedFooter.vue?vue&type=style&index=0&id=167c19ae&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "167c19ae",
  null
  
)

export default component.exports